// extracted by mini-css-extract-plugin
export var externalLink = "_dt-0";
export var internalLinkLabel = "_dt-1";